const AUTH_FLOW_ROUTES = new Set([
  'login',
  'register',
  'forgot-password',
  'reset-password',
  'oauth',
  'extension-auth',
]);

const PUBLIC_STATIC_ROUTES = new Set([
  'privacy',
  'terms',
  'contact',
]);

export const isPublicAuthRoute = (pathname = '') => {
  const segments = pathname.split('/').filter(Boolean);
  if (segments.length === 0) return false;
  if (AUTH_FLOW_ROUTES.has(segments[0])) return true;
  if (segments.length >= 2 && AUTH_FLOW_ROUTES.has(segments[1])) return true;
  return false;
};

export const isPublicStaticRoute = (pathname = '') => {
  const segments = pathname.split('/').filter(Boolean);
  if (segments.length === 0) return false;
  return PUBLIC_STATIC_ROUTES.has(segments[0]);
};
